import getMarkerListBounds from "@components/GoogleMap/_lib/getMarkerListBounds";

const fitMapToMarkersBounds = ({ markers, map }) => {
  if (!map || !markers?.length) {
    return;
  }

  const bounds = getMarkerListBounds(markers);
  map.fitBounds(bounds);
  if (markers.length === 1) {
    map.setZoom(15);
  }
};

export default fitMapToMarkersBounds;
